// extracted by mini-css-extract-plugin
export var content = "GettingStarted-module--content--3VxxJ";
export var step_container = "GettingStarted-module--step_container--2ldcH";
export var step_text_container = "GettingStarted-module--step_text_container--2lptj";
export var app_store_icons_container = "GettingStarted-module--app_store_icons_container--2GOML";